/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import { ROLE_LEVEL } from 'constants/roles'
import { useAuth } from 'context/auth'
import AdminUserControl from 'layouts/account/components/AdminUserControl'
import BaseLayout from 'layouts/account/components/BaseLayout'
import Billing from 'layouts/account/components/Billing'
import ChangePassword from 'layouts/account/components/ChangePassword'
import Header from 'layouts/account/components/Header'
import Logout from 'layouts/account/components/Logout'

function Settings(): JSX.Element {
	const { user } = useAuth()

	return (
		<BaseLayout>
			<MDBox mt={4}>
				<Grid container spacing={3}>
					<Grid item xs={12} lg={12}>
						<MDBox mb={3}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<Header />
								</Grid>
								{ROLE_LEVEL[2].includes(user.data.role) && (
									<Grid item xs={12}>
										<AdminUserControl />
									</Grid>
								)}
								{ROLE_LEVEL[1].includes(user.data.role) && (
									<Grid item xs={12}>
										<Billing />
									</Grid>
								)}
								<Grid item xs={12}>
									<ChangePassword />
								</Grid>
								<Grid item xs={12}>
									<Logout />
								</Grid>
							</Grid>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</BaseLayout>
	)
}

export default Settings
